
{
  "fr": {
    "configuratorGlassSettingsColorsRow": {
      "label": "Couleur\u00a0:"
    }
  }
}
